function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["searchable", "searchablePlaceholder", "attribute", "operator", "limit", "showMore", "showMoreLimit", "sortBy", "escapeFacetValues", "transformItems", "translations"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useRef, useState } from 'react';
import { useRefinementList } from 'react-instantsearch-core';
import { RefinementList as RefinementListUiComponent } from "../ui/RefinementList.js";
import { SearchBox as SearchBoxUiComponent } from "../ui/SearchBox.js";
export function RefinementList(_ref) {
  var searchable = _ref.searchable,
    searchablePlaceholder = _ref.searchablePlaceholder,
    attribute = _ref.attribute,
    operator = _ref.operator,
    limit = _ref.limit,
    showMore = _ref.showMore,
    showMoreLimit = _ref.showMoreLimit,
    sortBy = _ref.sortBy,
    escapeFacetValues = _ref.escapeFacetValues,
    transformItems = _ref.transformItems,
    translations = _ref.translations,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useRefinementList = useRefinementList({
      attribute: attribute,
      operator: operator,
      limit: limit,
      showMore: showMore,
      showMoreLimit: showMoreLimit,
      sortBy: sortBy,
      escapeFacetValues: escapeFacetValues,
      transformItems: transformItems
    }, {
      $$widgetType: 'ais.refinementList'
    }),
    canRefine = _useRefinementList.canRefine,
    canToggleShowMore = _useRefinementList.canToggleShowMore,
    isFromSearch = _useRefinementList.isFromSearch,
    isShowingMore = _useRefinementList.isShowingMore,
    items = _useRefinementList.items,
    refine = _useRefinementList.refine,
    searchForItems = _useRefinementList.searchForItems,
    toggleShowMore = _useRefinementList.toggleShowMore;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var inputRef = useRef(null);
  function setQuery(newQuery) {
    var compositionComplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    setInputValue(newQuery);
    if (compositionComplete) {
      searchForItems(newQuery);
    }
  }
  function onRefine(item) {
    refine(item.value);
    setQuery('');
  }
  function onChange(event) {
    var compositionComplete = event.type === 'compositionend' || !event.nativeEvent.isComposing;
    setQuery(event.currentTarget.value, compositionComplete);
  }
  function onReset() {
    setQuery('');
  }
  function onSubmit() {
    if (items.length > 0) {
      refine(items[0].value);
      setQuery('');
    }
  }
  var mergedTranslations = _objectSpread({
    resetButtonTitle: 'Clear the search query',
    submitButtonTitle: 'Submit the search query',
    noResultsText: 'No results.',
    showMoreButtonText: function showMoreButtonText(options) {
      return options.isShowingMore ? 'Show less' : 'Show more';
    }
  }, translations);
  var uiProps = {
    items: items,
    canRefine: canRefine,
    onRefine: onRefine,
    query: inputValue,
    searchBox: searchable && /*#__PURE__*/React.createElement(SearchBoxUiComponent, {
      inputRef: inputRef,
      placeholder: searchablePlaceholder,
      isSearchStalled: false,
      value: inputValue,
      onChange: onChange,
      onReset: onReset,
      onSubmit: onSubmit,
      translations: {
        submitButtonTitle: mergedTranslations.submitButtonTitle,
        resetButtonTitle: mergedTranslations.resetButtonTitle
      }
    }),
    noResults: searchable && isFromSearch && items.length === 0 && mergedTranslations.noResultsText,
    canToggleShowMore: canToggleShowMore,
    onToggleShowMore: toggleShowMore,
    isShowingMore: isShowingMore,
    translations: {
      showMoreButtonText: mergedTranslations.showMoreButtonText
    }
  };
  return /*#__PURE__*/React.createElement(RefinementListUiComponent, _extends({}, props, uiProps, {
    showMore: showMore
  }));
}